import { PayActionContext } from "./PayActionContext";
import usePreparePay from "./usePreparePay";
import usePay from "./usePay";
import { useContext } from "react";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";
import { t } from "i18next";

function usePayAction(modelConfig: any, index: any): any {
  const preparePay = usePreparePay();
  const preparePayFunction = (id: any) => preparePay(id);

  const onSuccessPay = () => {
    setShowModal(false);
    index();
  };

  const pay = usePay(modelConfig);

  const payFunction = () => pay(onSuccessPay);

  const contextInstance = useContext(PayActionContext);
  const { setShowModal } = contextInstance;

  const modalConfig = {
    contextInstance: contextInstance,
    title: "pay",
    onSubmit: () => payFunction(),
  };

  const actionTemplate = (
    <CrudModuleFactoryModal modalConfig={modalConfig}>
      {t(`are_you_sure_you_want_to_pay_this_${modelConfig.modelName}?`)}
    </CrudModuleFactoryModal>
  );

  /** END EDIT TABLE ACTION */

  return {
    preparePayFunction,
    actionTemplate,
  };
}

export default usePayAction;
